import React, { ComponentType } from "react";
import { TagAutoComplete } from "App/Atomics/AutoComplete";
import { findAlbumList } from "./findAlbumList";
import { components, OptionProps } from "react-select";
import { GRAY_5 } from "constants/baseColor";
import styled from "styled-components";
import { PRIMARY_COLOR_LIGHT } from "constants/color";

type Props = Pick<
  Parameters<typeof TagAutoComplete>[0],
  "style" | "className" | "isDisabled" | "defaultValue" | "defaultOptions" | "onChange" | "onBlur" | "placeholder"
>;

export const AlbumTagAutoComplete = ({
  style,
  className,
  isDisabled,
  defaultValue,
  onChange,
  onBlur,
  placeholder = "검색어 : (앨범명 + 가수명) or $ID"
}: Props) => {
  return (
    <TagAutoComplete
      placeholder={placeholder}
      isDisabled={isDisabled}
      defaultValue={defaultValue}
      delay={200}
      style={style}
      className={className}
      onChange={onChange}
      onBlur={onBlur}
      loadInfoList={findAlbumList}
      components={{ Option }}
    />
  );
};

const Option: ComponentType<OptionProps<any>> = ({ children, ...props }) => {
  return (
    <components.Option {...props}>
      <OptionWrapper>
        <span className="id">{props.data.id}</span>
        <span>{children}</span>
        <span className="extra">{props.data.extra.artist}</span>
      </OptionWrapper>
    </components.Option>
  );
};

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  .id {
    font-size: 9px;
    color: ${GRAY_5};
  }
  .extra {
    font-size: 11px;
    color: ${PRIMARY_COLOR_LIGHT};
  }
`;
